<template>
  <a class="skip-to-content" ref="skipLink" href="#main">{{ $t('content') }}</a>
  <Sprite />
  <SpriteLD />
  <h1 class="h6 visually-hidden" role="banner">Sportello Online - UNIGE</h1>

  <div class="dimmable">
    <LoadingPage />


    <AuthenticableHeader v-if="showHeaderFooter" />

    <div class="container mt-2">
      <span @click="changeLocale('it')" :style="{ fontWeight: currentLocale === 'it' ? 'bold' : 'normal', cursor: 'pointer'  }">IT</span> |
      <span @click="changeLocale('en')" :style="{ fontWeight: currentLocale === 'en' ? 'bold' : 'normal', cursor: 'pointer'  }">EN</span>
    </div>

    <router-view id="main" />


    <Footer id="footer" :version="version" :show-version="versionShow" v-if="showHeaderFooter" />

    <Notification />
    <CustomModal :modal="modal" />
  </div>
</template>

<style>
@import "assets/style.scss";

.skip-to-content {
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: -1;
  padding-inline: 1.75ch;
  padding-block: .75ch;
  border-radius: .5ch;
  background: white;
  color: black;
  font-weight: bold;
  opacity: 0;
}

.skip-to-content:focus-visible {
  outline-color: white;
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 3px;
  opacity: 1;
  z-index: 999;
}
</style>
<script lang="ts" setup>
import AuthenticableHeader from "@/layouts/common/AuthenticableHeader.vue";
import {Sprite, SpriteLD } from "cdp-fe-commons-layout";
import Footer from "@/layouts/common/Footer.vue"
import LoadingPage from "@/components/general/LoadingPage.vue";
import Notification from "@/components/general/Notification.vue";
import { EVENTS, subscribeEvent } from "@/emitter_mitt";
import CustomModal from "@/components/general/CustomModal.vue";
import { ref, Ref, watch,computed,shallowRef } from "vue";
import { IModal } from "@/interfaces/components/general/IModal";
import { ModalDimension } from "@/enums/components/general/ModalDimension";
import { ICustomComponent } from "@/interfaces/components/common/ICustomComponent";
import SetEmail from "@/components/user/SetEmail.vue";
import { useUserStore } from "@/stores/user";
import {useRoute} from "vue-router";
import {setLocale} from "@/i18n";
import { useServiceDetailStore } from "@/stores/service/serviceDetail";


const serviceDetailStore = useServiceDetailStore();
const currentLocale = ref(localStorage.getItem("locale") || "en");

function changeLocale(locale: string) {
  setLocale(locale);
  serviceDetailStore.setLanguage(locale);
  currentLocale.value = locale;
  localStorage.setItem("locale", locale); // Persist choice
}


const version: string = process.env.VUE_APP_VERSION;
const versionShow: boolean = process.env.VUE_APP_SHOW_VERSION === "true";

const userStore = useUserStore();

const modal: Ref<IModal> = shallowRef<IModal>({
  title: "Imposta email per notifiche",
  titleEn: "Set up email for notifications",
  closable: false,
  dimension: ModalDimension.MEDIUM,
  content: {
    render: SetEmail,
    events: {
      close: openCloseModal
    }
  } as ICustomComponent
} as IModal);

subscribeEvent(EVENTS.SET_EMAIL, openCloseModal);

watch(() => modal.value.show, () => {
  if (!modal.value.show)
    userStore.isAuthenticated();
});

const route = useRoute()
const skipLink = ref()

watch(
    () => route.path,
    () => {
      skipLink.value.focus()
    }
)

function openCloseModal() {
  modal.value.show = !modal.value.show;
  console.log('modal.value.show 2',modal.value.show)
}


// Check if the current route should have the header/footer
const showHeaderFooter = computed(() => {
  return route.meta.layout !== "no-layout"; // If layout is 'no-layout', hide header/footer
});
</script>
<style>

.btn-success {
  background: #006552 !important;
}
.btn-primary {
  background: #024080 !important;
}
.btn-dropdown {
  color: #024080 !important;
}
.icon.icon-primary {
  fill: #024080 !important;
}
.dropdown-item.list-item > span {
  color: #024080 !important;
}
.btn-outline-primary {
  color: #024080 !important;
  box-shadow: inset 0 0 0 2px #024080 !important;
}
.pagination .page-item .page-link[aria-current] {
  border: 1px solid #024080 !important;
  color: #024080 !important;
}
.language-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  cursor: pointer;
}

.language-option {
  cursor: pointer;
  color: #fff;
  text-decoration: none;
  padding: 4px;
}

.language-option.active {
  font-weight: bold;
  text-decoration: underline;
}
</style>
